/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { MapController } from '@deck.gl/core';

export class ChartController extends MapController {
    constructor(props) {
        super(props);
        this.invertPan = !this.invertPan;
    }
}
